import React from 'react'
import { ServicePage, Title, Desc, Actions, Image } from '../../components/service-page'
import { ReactComponent as Forbidden } from './images/forbidden.svg'

const title = 'Access Denied'
const desc = [
  'Sorry, you are not authorized to access this feature.'
]

const UnauthorizedPage = props => {
  return (
    <ServicePage maxContentWidth={1440} inset={3}>
      <Title>{title}</Title>
      <Desc text={desc} />
      <Image imageComponent={Forbidden} />
      <Actions />
    </ServicePage>
  )
}

export default UnauthorizedPage
